export const newsFound = ({newsFound, selectedCategory}) => {
  let newsFiltered = newsFound
  if (selectedCategory) {
    newsFiltered = newsFound.filter((i) => parseInt(i.categoryId, 10) === parseInt(selectedCategory, 10))
  }
  return newsFiltered
}

export const selectedCategory = ({selectedCategory}) => selectedCategory



// WEBPACK FOOTER //
// ./src/app/config/store/modules/search/getters.js